<template>
    <div class="login-sso">
        <Logo />
        <div class="sso-error" v-if="this.error">
            <b-alert variant="danger" show>{{this.error}}</b-alert>
            <router-link :to="{'name':'login'}">
                <b-button variant="default" block>Back to login</b-button>
            </router-link>
        </div>
        <b-alert variant="info" v-else show>Logging in...</b-alert>
    </div>
</template>

<script>
    import Logo from "../../components/authentication/Logo";
    export default {
        name: "LoginSSO",
        components: {Logo},
        data: function() {
            return {
                error: null,
            }
        },
        created: function() {
            let code = this.$route.query.code;
            if (code === undefined) {
                this.error = 'Login information not provided';
            } else {
                console.log('[AUTH] Starting V1 SSO login');
                let redirectTo = encodeURI(process.env.VUE_APP_SSO_REDIRECT);
                
                // SSO login using V1 API only (SSO codes are single-use)
                // Use raw $http instead of $api.v1 since we don't have auth token yet
                const v1SSOPromise = this.$http.get(process.env.VUE_APP_API_ROOT + `auth/login/sso/${code}?redirectTo=${redirectTo}`)
                    .then(response => {
                        console.log('[AUTH] V1 SSO login successful');
                        // Store V1 token immediately
                        this.$store.dispatch('authentication/storeV1Token', {
                            token: response.body.token
                        });
                        return {
                            token: response.body.token,
                            roles: response.body.roles,
                            type: 'v1'
                        };
                    })
                    .catch(error => {
                        console.error('[AUTH] V1 SSO login failed:', error);
                        throw error;
                    });
                    
                // TODO: V2 SSO - SSO codes are single-use so we can't call both APIs
                // Need backend solution to return both tokens from single SSO call
                // const v2SSOPromise = this.$api.v2.get(`auth/login/sso/${code}?redirectTo=${redirectTo}`)
                //     .then(response => {
                //         console.log('[AUTH] V2 SSO login successful');
                //         this.$store.dispatch('authentication/storeV2Token', {
                //             token: response.body.token
                //         });
                //         return {
                //             token: response.body.token,
                //             roles: response.body.roles,
                //             type: 'v2'
                //         };
                //     })
                //     .catch(error => {
                //         console.error('[AUTH] V2 SSO login failed:', error);
                //         throw error;
                //     });
                
                // Process V1 SSO login only
                v1SSOPromise.then((v1Result) => {
                    console.log('[AUTH] V1 SSO login complete');
                    
                    const admin = v1Result.roles.indexOf('Admin') > -1;
                    
                    // Store main login details (roles and admin status)
                    this.$store.dispatch('authentication/storeLoginDetails', {
                        isAdmin: admin,
                        roles: v1Result.roles
                    }).then(() => {
                        console.log('[AUTH] SSO login complete');
                        if (this.$route.params.nextUrl != null) {
                            this.$router.push(this.$route.params.nextUrl);
                        } else {
                            this.$router.push({name: 'dashboard-home'})
                        }
                    });
                }).catch((error) => {
                    // If SSO login fails, show error
                    this.error = error.body?.message || 'SSO login failed';
                });
            }
        }
    }
</script>

<style scoped>
    .login-sso {
        width: 100%;
        max-width: 330px;
        padding: 15px;
        margin: auto;
    }
</style>